export const looksLikePOId = (value: string): boolean => /^(PO|UK|EU)-/i.test(value);

export const looksLikeTOId = (value: string): boolean => /^TO-/i.test(value);

export const normalizePOInput = (value: string): string =>
  /^(UK|EU)-/i.test(value) ? `PO-${value.replace(/^(UK|EU)-/i, "")}` : value;
